import script from "./Wallet.vue?vue&type=script&setup=true&lang=js"
export * from "./Wallet.vue?vue&type=script&setup=true&lang=js"

import "./Wallet.vue?vue&type=style&index=0&id=4a62f6de&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4a62f6de"]])

export default __exports__